import {
    createPrivacyEffect
} from './index';
import {
    room,
    vb,
    switchVideo,
    deviceManager,
    CONV_STORAGE,
    Video,
    cameraEnabledIcon,
    getIdealResolution,
    getFrameRate
} from '../../libs/roomnew';
import { disableSimlucastLayers } from '../simulcast/Layers';
import { getLocalKinoTrack, storeLocalTrack } from '../base/tracks/functions';
import { MEDIA_TYPE } from '../base/tracks/constants';
export default class PrivacyMode {
    constructor() {
        this.enabled = false;
        this.options = {
            blurValue: 40
        };
        this.btnLabel = `Privacy Mode`;
        this.privacyModeIcon = `<i class="icofont-invisible"></i></div>`;
        this.btn = null;
        this.btnSwitch = null;
        this.vbEffect = null;
        this.deviceListButton = null;
        this.effectSwitching = false;
        this.cameraSectionPrivacy = $('#privacy-mode-camera-section');
    };

    addOptionButton() {
        var s = this;
        try {
            s.btnSwitch = $('<label />', {
                class: 'switch',
                html: [`<input type="checkbox" id="privacy-mode-checkbox" ${s.enabled ? 'checked' : ''}><span class="kino-slider round"></span>`],
            }).on('change', 'input', function () {
                if (s.enabled) {
                    s.stopPrivacyMode();
                } else {
                    s.startPrivacyMode();
                }
            });

            // s.btn = $("<div/>", {
            //     class: 'dropdown-item privacy-mode',
            //     html: [`<div class="kinetx-icon"><i class="icofont-invisible"></i></div>`, s.btnLabel, s.btnSwitch]
            // }).on('click', function (e) {
            //     e.stopPropagation();
            // });
            s.optionIcon = $('<div/>', {
                class: "option-icon",
                id: "speakerHighlightIcon",
                html: s.privacyModeIcon,
            });
            s.optionName = $('<div/>', {
                class: "option-name",
                id: "option-name-privacyMode",
                html: s.btnLabel,
            });
            s.optionAction = $('<div/>', {
                class: "option-action kino-toggle",
                id: "option-action-privacyMode",
                html: s.btnSwitch,
            });
            s.optionDescription = $('<div/>', {
                class: "option-description",
                html: [ s.optionName, s.optionAction],
            });
            s.btn = $('<label/>', {
                for: 'privacy-mode-checkbox',
                class: 'option',
                id: 'privacyModeBtn',
                html: [s.optionIcon, s.optionDescription],
            }).on('click',function(e){
                e.stopPropagation();
            });
            $("#option-list").append(s.btn);
            //$("#kino-options-list").prepend(s.btn);
        } catch (error) {
            console.error("Error adding privacy mode button", error);
        }

    };

    // appendPrivacyButton(el) {
    //     var pm = this;
    //     this.deviceListButton = $("<a/>", {
    //         class: 'dropdown-item privacy-mode-list-item',
    //         href: '#',
    //         style: `pointer-events:${this.effectSwitching ? "none" : "all"}`,
    //         html: `${this.enabled ? "Disable" : "Enable"} privacy mode`
    //     }).on('click', function () {
    //         if (pm.enabled) {
    //             pm.stopPrivacyMode();
    //         } else {
    //             pm.startPrivacyMode();
    //         }
    //     });
    //     el.append(this.deviceListButton);

    // };

    async startPrivacyMode(track = null) {
        var pm = this;
        try {
            if (Video.isSharingScreen && !track) {
                pm.keepDisabledIfScreenSharing();
                return;
            }
            this.disableButtons();
            let usingVb = false;
            if (vb.effectPlaying) {
                this.vbEffect = vb.effect;
                vb.effectPlaying = false;
                usingVb = true;
            }
            if (this.streamEffect) {
                this.streamEffect.stopEffect();
                this.streamEffect._inputVideoElement.pause();
                this.streamEffect._inputVideoElement.srcObject=null;
                this.streamEffect._inputVideoElement.load();
                this.streamEffect = undefined;
            }
            if (track) {
                this.enableButtons();
                return this.modifyStream(track);
                //just play effect in local
            } else {
                this.enabled = true;
                let currentVideoTrack=getLocalKinoTrack(MEDIA_TYPE.VIDEO);
                let currentMuted=currentVideoTrack ? currentVideoTrack.isMuted() :true;
                let deviceId = currentVideoTrack ? currentVideoTrack.getDeviceId() : deviceManager.lastUsedCamera();
                deviceManager.captureCamera(deviceId,{
                    resolution: getIdealResolution(),
                    frameRate: getFrameRate()
                }).then(async (cameraTrack) => {
                    let modifiedTrack = await pm.modifyStream(cameraTrack);
                    if(currentVideoTrack.stream){
                        currentVideoTrack.stream.getTracks().forEach(track => {
                            track.stop()
                        })
                    }
                    await room.replaceTrack(currentVideoTrack, modifiedTrack);

                    storeLocalTrack(modifiedTrack)

                    if(currentMuted){
                        this.unmuteCameraIcon();
                    }
                    if(currentVideoTrack._originalStream){
                        currentVideoTrack._originalStream.getTracks().forEach(track => {
                            track.stop()
                        })
                    }
                    disableSimlucastLayers([1,2]);
                    console.warn(`Successfully replaced Privacy effect track using deviceId ${deviceId}`)
                    this.enableButtons();
                    if(usingVb && vb.streamEffect){
                        vb.streamEffect.stopEffect();
                        vb.streamEffect._inputVideoElement.pause();
                        vb.streamEffect._inputVideoElement.srcObject=null;
                        vb.streamEffect._inputVideoElement.load();
                        vb.streamEffect=undefined;
                    }
                }).catch(error => {
                    this.enableButtons();
                    console.error(`Privacy mode capture camera error`, error);
                });
            }
            //this.enabled=true;
        } catch (error) {
            this.enabled = false;
            this.enableButtons();
            console.error("Error playing privacy mode", error);
        }
        this.updateUIButtons();
    };

    async modifyStream(track) {
        this.streamEffect = await createPrivacyEffect(this.options);
        track._originalStream=track.stream;
        this.originalStream=track.stream;
        let vbStream = this.streamEffect.startEffect(track.stream);
        track.stream = vbStream;
        track.track = track.stream.getTracks()[0];
        return track;
    };

    unmuteCameraIcon(){
        try {
            // $('#room-mute-video').attr('data-original-title', 'Camera On');
            // $('#room-mute-video').attr('title', 'Camera On');
            // $('#room-mute-video').tooltip('hide');
            $('#room-mute-video').html(cameraEnabledIcon);
            room.setLocalParticipantProperty('video_muted', false);
            Video.cameraMuted(room.myUserId(),false);
        } catch (error) {
            console.error("unmute camera ",error)
        }

    };

    stopPrivacyMode() {
        var pm = this;
        try {
            if (Video.isSharingScreen) {
                pm.keepEnabledIfScreenSharing();
                return;
            }
            this.disableButtons();
            if (this.vbEffect) {
                vb.effect = this.vbEffect;
                vb.runEffect();
                this.vbEffect = null;
            } else {
                let currentVideoTrack=getLocalKinoTrack(MEDIA_TYPE.VIDEO);
                if(currentVideoTrack){
                    if(!currentVideoTrack.isMuted()){
                        if(currentVideoTrack._originalStream){
                            currentVideoTrack._originalStream.getTracks().forEach(t => t.stop());
                            currentVideoTrack._originalStream=undefined;
                        }
                      switchVideo(currentVideoTrack.getDeviceId());
                    }

                }else{
                    switchVideo(deviceManager.lastUsedCamera());
                }
            }
            this.enabled = false;
            if (this.streamEffect) {
                this.streamEffect.stopEffect();
                this.streamEffect._inputVideoElement.pause();
                this.streamEffect._inputVideoElement.srcObject=null;
                this.streamEffect._inputVideoElement.load();
                this.streamEffect = undefined;
            }
            this.enableButtons();
        } catch (error) {
            this.enabled = false;
            this.enableButtons();
            console.error("Error stoping privacy mode", error);
        }
        this.updateUIButtons();
    };

    updateUIButtons() {
        if (this.enabled) {
            $("#privacy-mode-checkbox").prop('checked', true);
        } else {
            $("#privacy-mode-checkbox").prop('checked', false);
        }
    };

    disableButtons() {
        let pm = this;
        pm.effectSwitching = true;
        pm.btn && pm.btn.css("pointer-events", "none");
        $('#room-mute-video').attr("disabled",true);
        $('#privacy-mode-camera-settings').attr('disabled', true)
        // $('#privacy-mode-camera-section').addClass('button-disabled')
    };
    enableButtons() {
        let pm = this;
        setTimeout(() => {
            pm.effectSwitching = false;
            $('#room-mute-video').removeAttr("disabled");
            $('#privacy-mode-camera-settings').removeAttr('disabled')
            // $('#privacy-mode-camera-section').removeClass('button-disabled')
            pm.btn && pm.btn.css("pointer-events", "all");
        }, 2000);   //card id 363
    };

    keepDisabledIfScreenSharing(){
        $('#privacy-mode-checkbox').prop("checked", false);
        $('#privacy-mode-camera-settings').prop("checked", false);
        $('#privacyModeBtn').tooltip()
    };

    keepEnabledIfScreenSharing(){
        $('#privacy-mode-checkbox').prop("checked", true);
        $('#privacy-mode-camera-settings').prop("checked", true);
        $('#privacyModeBtn').tooltip()
    };

};
